export const WALLET_PACKAGES = [
  { id: "usd_10", amountCents: 1_000, label: "$10" },
  { id: "usd_25", amountCents: 2_500, label: "$25", popular: true },
  { id: "usd_50", amountCents: 5_000, label: "$50" },
  { id: "usd_100", amountCents: 10_000, label: "$100" },
] as const;

export type WalletPackageId = (typeof WALLET_PACKAGES)[number]["id"];

export function walletPackageById(id: string) {
  return WALLET_PACKAGES.find((entry) => entry.id === id);
}
